import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import logo from "../../assets/plant-icon.svg";
import { useAuth0 } from "../../react-auth0-spa";

import {
  updatePlant,
  onDeletePromptModal
} from './actions';

import './styles.scss';

const CardItem = ({
  id,
  name,
  onDeletePromptModal,
  plantKeyId,
  updatePlant,
  wateringCycle,
  waterStartTime,
}) => {
  const { user } = useAuth0();
  const activeClass = 'item-edit-active';
  const removePlant = () => {
    onDeletePromptModal(true, plantKeyId);
  };
  const formFeilds = {
    name,
    wateringCycle: wateringCycle || 'none',
    waterStartTime: waterStartTime || new Date().toUTCString(),
  };
  const [editClass, setEditClass] = useState('');
  const [stateFeilds, setEditInputFeilds] = useState(formFeilds);
  const [isActive, setisActive] = useState(false);
  const toggleEdit = () => {
    if(editClass === activeClass) {
      setEditClass('')
      setisActive(!isActive);
      setEditInputFeilds(formFeilds);
    } else {
      setEditClass(activeClass);
      setisActive(!isActive);
    }
  };
  const onChangeInput = (feildToUpdate, e) => {
    setEditInputFeilds({
      ...stateFeilds,
      [feildToUpdate]: e.currentTarget.value
    });
  };
  const onSubmit = async (feilds, e) => {
    e.preventDefault();
    e.persist();

    const userId = user.sub.split('|')[1];

    toggleEdit();
    resetFeilds(feilds);
    updatePlant(userId, feilds, plantKeyId);
  };
  const resetFeilds = (feilds) => {
    const formElm = document.getElementById(`${id}_edit-plant-form`);
    formElm.reset();
    setEditInputFeilds({ ...stateFeilds, ...feilds });
  };
  const setWaterStartTime = (date) => {
    setEditInputFeilds({ ...stateFeilds, waterStartTime: date.toUTCString() });
  };
  const hasWaterCycle = stateFeilds.wateringCycle !== 'none';
  const getNextWateringDay = () => {
    const date = new Date(stateFeilds.waterStartTime);
    let days = 0;
    switch (stateFeilds.wateringCycle) {
      case 'daily':
        days = 1;
        break;
      case 'weekly':
        days = 7;
        break;
      case 'bi-weekly':
        days = 14;
        break;
      default:
        days = 0;
    };
    date.setDate(date.getDate() + days);

    return hasWaterCycle ? date.toDateString() : 'No Schedule set';
  };
  const lastWateredDate = new Date(stateFeilds.waterStartTime);
  const lastWateredTime = lastWateredDate.toDateString();
  const currentDateObj = new Date();
  const currentDateInt = currentDateObj.getDate();
  const hasLastWatered = currentDateInt > lastWateredDate.getDate();

  return (
    <>
      <div className={`card-item ${editClass}`}>
        <div className="edit-btn-container">
          <div className="edit-btn text-success">
            <FontAwesomeIcon
              icon={faEdit}
              onClick={toggleEdit}
              size="lg"
            />
          </div>
        </div>
        <Container>
          <Row>
            <Col className="image-container">
              <img
                alt="plant logo"
                className="app-logo"
                src={logo}
                width="100"
              />
            </Col>
            <Col className="content-section">
              <p className="text-highlight">
                {stateFeilds.name}
              </p>
              <p className="text-sub">
                <span className="text-label">Next Watering Time</span>
                <span className="text-content active">
                  {getNextWateringDay()}
                </span>
              </p>
              <p className="text-sub">
                {hasLastWatered && hasWaterCycle && (
                  <>
                    <span className="text-label">Last Watered</span>
                    <span
                      className="text-content in-active">
                      {lastWateredTime}
                    </span>
                  </>
                )}
              </p>
            </Col>
          </Row>
        </Container>
        <Col className={`edit-container ${editClass}`}>
          <Row className="edit-form-section">
            <h5 className="title">Edit Plant</h5>
            <Form
              id={`${id}_edit-plant-form`}
              className="edit-plant-form"
              onSubmit={onSubmit.bind(this, stateFeilds)}
            >
              <FormGroup row>
                <Col className="edit-plant-form_input">
                  <Label for="plantName">Name</Label>
                  <Input
                    id="plantName"
                    name="name"
                    onChange={onChangeInput.bind(this, 'name')}
                    placeholder={stateFeilds.name}
                    type="plantName"
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Col className="edit-plant-form_input water-start-time">
                  <Label for="waterStartTime">
                    Watering Start Time
                  </Label>
                  <DatePicker
                    className="water-start-time-input form-control"
                    id="water-start-time"
                    name="waterStartTime"
                    onChange={setWaterStartTime.bind(this)}
                    selected={Date.parse(stateFeilds.waterStartTime)}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Col className="edit-plant-form_input">
                  <Label for="wateringCycle">Watering Cycle</Label>
                  <Input
                    id="watering-cycle"
                    name="wateringCycle"
                    onChange={onChangeInput.bind(this, 'wateringCycle')}
                    type="select"
                    value={stateFeilds.wateringCycle}
                  >
                    <option value={'none'}>
                      Select Water Cycle
                    </option>
                    <option value={'daily'}>
                      daily
                    </option>
                    <option value={'weekly'}>
                      weekly
                    </option>
                    <option value={'bi-weekly'}>
                      bi-weekly
                    </option>
                  </Input>
                </Col>
              </FormGroup>
              <div className="btn-container">
                <Button
                  className="btn-close"
                  color="secondary"
                  onClick={toggleEdit}
                >
                  close
                </Button>
                <Button
                  className="btn-delete"
                  color="danger"
                  onClick={removePlant}
                >
                  Delete
                </Button>
                <Button
                  className="btn-submit"
                  color="success"
                >
                  Save
                </Button>
              </div>
            </Form>
          </Row>
        </Col>
      </div>
    </>
  );
};

CardItem.defaultProps = {
  name: '',
  plantKeyId: ''
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onDeletePromptModal,
  updatePlant,
}, dispatch);

export default connect(null, mapDispatchToProps)(CardItem);
